module.exports = __webpack_public_path__ + "static/sustainable-lodging-3-5280ced59166763b7b1d348eb8be437e.jpg";